export const unpicked = 0;
export const homewin = 1;
export const awaywin = 2;
export const tiegame = 3;

export const win = 'W';
export const loss = 'L';
export const tie = 'T';
export const BYE = 'BYE';

export const AFC = 'AFC';
export const NFC = 'NFC';

//!global variable for current season
//Note you must update SOS in Teams/NFL_Teams.js too when updating to new season
export const SEASON = 2026;
